import { useNavigate, useOutletContext } from 'react-router';

import { Gaveta } from '@/components/Gaveta/Gaveta';
import { FormularioDeNovaAcao } from '@/features/acoes/FormularioDeNovaAcao';
import type { ContextoDaListaDeAcoes } from '@/features/acoes/contextoDaLista';

/**
 * Criação de ação numa gaveta sobre a lista.
 *
 * POR QUE ISTO É UMA ROTA, E NÃO ESTADO DA LISTA
 *
 * A gaveta tem URL própria — /acoes/nova — e é rota filha de /acoes, então a lista
 * continua montada atrás. Com a abertura em estado local, F5 e link compartilhado
 * cairiam na lista sem a gaveta, e o botão Voltar do navegador sairia de /acoes em vez
 * de fechar o painel.
 *
 * AO CRIAR, VOLTA PARA A LISTA em vez de ir para o detalhe. Quem cadastra costuma
 * cadastrar várias em sequência, e mandar para o detalhe cobraria uma volta a cada
 * ação. O aviso na lista oferece o detalhe como link, para quem quiser.
 */
export function GavetaDeNovaAcao() {
  const navegar = useNavigate();
  const { aoCriar } = useOutletContext<ContextoDaListaDeAcoes>();

  const fechar = () => {
    /*
      `..` em vez de '/acoes': a gaveta é filha dos dois painéis, e quem abriu a partir da
      fila precisa voltar para a fila. Caminho fixo devolveria a pessoa para o painel do
      CS, perdendo o recorte e o filtro dela.

      `replace` para a gaveta não virar um passo no histórico: quem fecha e aperta Voltar
      espera sair da lista, não reabrir o formulário que acabou de descartar.
    */
    void navegar('..', { replace: true, relative: 'path' });
  };

  return (
    <Gaveta
      titulo="Nova ação"
      descricao="A ação nasce como rascunho. Você revisa e envia para análise depois, na tela dela."
      aoFechar={fechar}
    >
      <FormularioDeNovaAcao
        aoCriar={(acao) => {
          aoCriar(acao);
          fechar();
        }}
        aoDesistir={fechar}
      />
    </Gaveta>
  );
}
